/** Splits a command line into words, honouring '…' and "…" quotes (npx -y pkg "/a b"). */
export function splitCommand(line: string): string[] {
  const out: string[] = [];
  let cur = "", quote: string | null = null, any = false;
  for (const ch of line.trim()) {
    if (quote) { if (ch === quote) quote = null; else cur += ch; continue; }
    if (ch === "'" || ch === '"') { quote = ch; any = true; continue; }
    if (/\s/.test(ch)) { if (cur || any) out.push(cur); cur = ""; any = false; continue; }
    cur += ch;
  }
  if (cur || any) out.push(cur);
  return out;
}
